import React from 'react';

import appConfig from '../../config/appConfig';
import {twx} from '../../utils/tailwindUtils';
import ProductImage from './ProductImage';

const DeviceImage = (props) => {
    const {className, imgClassName, device, holder, altMainImg, altHolderImg, isHolderSingle, ignoreRestrictedMarket} =
        props;

    const isRestrictedMarket = appConfig.getIsRestrictedMarket();
    const restrictedAssetsImagePath = appConfig.getRestrictedAssetsImagePath();

    // Do not show anything if market is restricted and restricted image path is empty
    if (isRestrictedMarket && !ignoreRestrictedMarket && !restrictedAssetsImagePath) return;

    const restrictedAssetsPath = !ignoreRestrictedMarket && restrictedAssetsImagePath;

    return (
        <div className={twx('relative', className)}>
            {restrictedAssetsPath && (
                <ProductImage alt={altMainImg} mediaIdList={restrictedAssetsImagePath} imgClassName={imgClassName} />
            )}

            {!restrictedAssetsPath && !isHolderSingle && device && (
                <ProductImage
                    alt={altMainImg}
                    key={device.mediaId}
                    mediaIdList={device.mediaId}
                    type={device.type}
                    imgClassName={imgClassName}
                />
            )}

            {!restrictedAssetsPath && device?.isHolderConnected && holder?.type && (
                <ProductImage
                    isHolderSingle={isHolderSingle}
                    alt={altHolderImg}
                    key={isHolderSingle ? holder.singleHolderMediaId : holder.mediaId}
                    mediaIdList={isHolderSingle ? holder.singleHolderMediaId : holder.mediaId}
                    type={holder.type}
                    imgClassName={imgClassName}
                />
            )}
        </div>
    );
};

export default DeviceImage;
